/* FJC 2026-10-09: "Notify me when back in stock" (design: TFJC_NOTIFY ME.pdf).

   - Shows the Notify Me button (rendered in the Add to Cart slot by
     snippets/product-template.liquid) and hides Add to Cart while the resolved
     variant is sold out (stock 0 with policy deny: Shopify "available" false;
     made-to-order variants stay purchasable and keep Add to Cart). The state is
     read from the hidden [data-fjc-variant-title] span
     (snippets/fjc-variant-state.liquid): inside the picker that Eurus re-renders
     on every variant update, or, for single-variant products (no picker), inside
     the Notify Me wrapper itself (2026-10-12).
   - With a size picker and no size chosen yet, a click shows
     "Please select a ring size first." (the pickers expose
     window.fjcSizeChosenGetters[sectionId]).
   - Opens the drawer (snippets/fjc-notify-me-drawer.liquid), fills the hidden
     product/variant fields and submits by fetch, then shows the success view.

   Submission backend: window.fjcNotifyMe.submit(form, details) returns a
   Promise that resolves on success and rejects with an Error on failure. The
   default posts the Shopify contact form (the store receives the request by
   email). Replace that one function to use a back-in-stock service instead.
   Shopify's spam-protection captcha is honoured: when it has bound the form,
   its token is in the form data before the fetch runs (see hookCaptchaSubmit). */
(function () {
  'use strict';

  var api = window.fjcNotifyMe = window.fjcNotifyMe || {};

  function stateFor(sectionId) {
    var source = document.querySelector('#variant-update-' + sectionId + ' [data-fjc-variant-title]')
      || document.querySelector('#fjc-notify-me-' + sectionId + ' [data-fjc-variant-title]');
    if (!source) return null;
    return {
      available: source.getAttribute('data-fjc-variant-available') !== 'false',
      variantId: source.getAttribute('data-fjc-variant-id') || '',
      variantName: source.getAttribute('data-fjc-variant-name') || '',
      sku: source.getAttribute('data-fjc-variant-sku') || '',
      displayTitle: source.textContent.trim(),
      sizeLabel: source.getAttribute('data-fjc-size-label') || '',
      madeToOrder: source.getAttribute('data-fjc-variant-mto') === 'true',
      sizePicker: source.getAttribute('data-fjc-size-picker') === 'true'
    };
  }

  function sizeChosen(sectionId) {
    var getters = window.fjcSizeChosenGetters;
    var getter = getters && getters[sectionId];
    return getter ? !!getter() : true;
  }

  function showError(wrap, text) {
    var err = wrap.querySelector('.fjc-notify-me__error');
    if (!err) return;
    err.textContent = text;
    err.hidden = false;
  }
  function hideError(wrap) {
    var err = wrap.querySelector('.fjc-notify-me__error');
    if (err) err.hidden = true;
  }

  // Show/hide the button for one product section, swapping it with Add to Cart.
  function sync(wrap) {
    var sectionId = wrap.getAttribute('data-fjc-notify-me');
    var state = stateFor(sectionId);
    var soldOut = !!state && !state.available;
    var atc = document.getElementById('x-atc-button-' + sectionId);
    wrap.hidden = !soldOut;
    if (atc) {
      if (soldOut) {
        atc.style.setProperty('display', 'none', 'important');
        wrap._fjcHidAtc = true;
      } else if (wrap._fjcHidAtc) {
        // Only undo our own hiding; the theme may hide the button itself by setting.
        atc.style.removeProperty('display');
        wrap._fjcHidAtc = false;
      }
    }
    if (!soldOut || sizeChosen(sectionId)) hideError(wrap);
    // 2026-10-19: "Dispatches within 30 working days" under Add to Cart, for a made-to-order
    // variant of a product without a size picker (sold-out variants show Notify Me instead).
    var dispatch = document.getElementById('fjc-dispatch-' + sectionId);
    if (dispatch) dispatch.hidden = !(state && state.available && state.madeToOrder && !state.sizePicker);
  }

  function syncAll() {
    var wraps = document.querySelectorAll('[data-fjc-notify-me]');
    Array.prototype.forEach.call(wraps, sync);
  }

  /* ---------------- Drawer ---------------- */

  var drawer = document.getElementById('fjc-notify-me-drawer');
  var lastTrigger = null;

  function view(name) {
    if (!drawer) return null;
    return drawer.querySelector('[data-fjc-notify-view="' + name + '"]');
  }

  function showView(name) {
    var formView = view('form');
    var successView = view('success');
    if (formView) formView.hidden = name !== 'form';
    if (successView) successView.hidden = name !== 'success';
  }

  function setDrawerError(text) {
    var err = drawer ? drawer.querySelector('[data-fjc-notify-error]') : null;
    if (!err) return;
    err.textContent = text || '';
    err.hidden = !text;
  }

  function fillFields(details) {
    if (!drawer) return;
    var map = {
      product: details.productTitle,
      variant: details.variantName,
      sku: details.sku,
      variant_id: details.variantId,
      url: details.url
    };
    Object.keys(map).forEach(function (key) {
      var input = drawer.querySelector('[data-fjc-notify-field="' + key + '"]');
      if (input) input.value = map[key] || '';
    });
  }

  function openDrawer(details, trigger) {
    if (!drawer) return;
    lastTrigger = trigger || null;
    fillFields(details);
    setDrawerError('');
    showView('form');
    var submit = drawer.querySelector('[data-fjc-notify-submit]');
    if (submit) submit.disabled = false;
    drawer.classList.add('cp-email-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fjc-drawer-open');
    var email = drawer.querySelector('input[type="email"]');
    setTimeout(function () { if (email) email.focus(); }, 380);
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('cp-email-drawer--open')) return;
    drawer.classList.remove('cp-email-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fjc-drawer-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  api.open = openDrawer;
  api.close = closeDrawer;

  /* ---------------- Submission ---------------- */

  // Default backend: the Shopify contact form rendered in the drawer
  // ({% form 'contact' %}), posted by fetch. Shopify answers with a redirect
  // back to the page (contact_posted=true) on success, or sends the request to
  // its spam challenge page, which cannot be completed from a fetch.
  api.submit = api.submit || function (form) {
    var body = new FormData(form);
    return fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      if (/\/challenge/.test(response.url || '')) throw new Error('challenge');
      return true;
    });
  };

  var inFlight = false;

  // Posts the form through api.submit and switches to the success view. Reached from
  // handleSubmit, or from form.submit() when Shopify's captcha provider has added its
  // token (see hookCaptchaSubmit).
  function runSubmit(form) {
    if (!drawer || inFlight) return;
    inFlight = true;
    var submit = form.querySelector('[data-fjc-notify-submit]');
    if (submit) submit.disabled = true;
    setDrawerError('');
    var details = {
      productTitle: (form.querySelector('[data-fjc-notify-field="product"]') || {}).value,
      variantName: (form.querySelector('[data-fjc-notify-field="variant"]') || {}).value,
      sku: (form.querySelector('[data-fjc-notify-field="sku"]') || {}).value,
      variantId: (form.querySelector('[data-fjc-notify-field="variant_id"]') || {}).value,
      url: (form.querySelector('[data-fjc-notify-field="url"]') || {}).value,
      email: (form.querySelector('input[type="email"]') || {}).value
    };
    Promise.resolve()
      .then(function () { return api.submit(form, details); })
      .then(function () {
        inFlight = false;
        showView('success');
        var panel = drawer.querySelector('.cp-email-drawer__panel');
        if (panel) { panel.scrollTop = 0; panel.focus(); }
      })
      .catch(function () {
        inFlight = false;
        if (submit) submit.disabled = false;
        setDrawerError('Sorry, we could not save your request just now. Please try again in a moment, or contact us and we will add you to the list.');
      });
  }

  // 2026-10-12: Shopify's spam protection (the captcha-bootstrap script plus its
  // hCaptcha/reCAPTCHA provider, present when "Spam protection" is on for the store)
  // binds every /contact form the first time it is focused. On submit the provider
  // calls preventDefault(), fetches a token, writes it into the form and then calls
  // form.submit(): a native submission that reloads the page, loses this drawer and
  // auto-opens the Contact Us drawer's thank-you view. The provider captures
  // form.submit when it binds the form, so an own submit() installed before that
  // point makes the provider hand the token-carrying form to this script instead.
  function captchaBound(form) {
    return form.dataset.hcaptchaBound === 'true' || form.dataset.recaptchaBound === 'true';
  }

  function hookCaptchaSubmit() {
    var form = document.getElementById('fjc-notify-me-form');
    if (!form || form._fjcSubmitHooked) return;
    form._fjcSubmitHooked = true;
    try {
      form.submit = function () { runSubmit(form); };
    } catch (e) { /* read-only in some old engines; the fetch path below still works */ }
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!drawer || !drawer.contains(form) || form.id !== 'fjc-notify-me-form') return;
    e.preventDefault();
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
    if (captchaBound(form)) {
      // The provider's own submit listener ran first and will call form.submit()
      // (runSubmit) once it has a token; posting here too would send the request twice.
      // Keep the button quiet meanwhile, but free it again if the token step is abandoned.
      var submit = form.querySelector('[data-fjc-notify-submit]');
      if (submit) {
        submit.disabled = true;
        setTimeout(function () { if (!inFlight) submit.disabled = false; }, 6000);
      }
      return;
    }
    runSubmit(form);
  }

  /* ---------------- Wiring ---------------- */

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var openBtn = target.closest('[data-fjc-notify-me-open]');
    if (openBtn) {
      e.preventDefault();
      var wrap = openBtn.closest('[data-fjc-notify-me]');
      if (!wrap) return;
      var sectionId = wrap.getAttribute('data-fjc-notify-me');
      var state = stateFor(sectionId);
      if (!state) return;
      if (!sizeChosen(sectionId)) {
        showError(wrap, 'Please select a ' + (state.sizeLabel || 'size') + ' first.');
        return;
      }
      hideError(wrap);
      var url = wrap.getAttribute('data-fjc-product-url') || '';
      if (state.variantId) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + state.variantId;
      openDrawer({
        productTitle: state.displayTitle || wrap.getAttribute('data-fjc-product-title') || '',
        variantName: state.variantName,
        sku: state.sku,
        variantId: state.variantId,
        url: url
      }, openBtn);
      return;
    }

    if (target.closest('[data-fjc-notify-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', handleSubmit);
  // Before any focus can reach the form (the drawer is closed until a click), so the
  // captcha provider captures this script's submit() rather than the native one.
  hookCaptchaSubmit();

  // Eurus re-renders the picker (and the hidden state span) on every variant change.
  function watchSections() {
    var wraps = document.querySelectorAll('[data-fjc-notify-me]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap._fjcNotifyWatched) return;
      wrap._fjcNotifyWatched = true;
      var sectionId = wrap.getAttribute('data-fjc-notify-me');
      document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function () {
        setTimeout(function () { sync(wrap); }, 0);
        setTimeout(function () { sync(wrap); }, 80);
      });
      // The size pickers change the hidden radio (and so the resolved variant) on
      // drawer picks and colour changes; a delegated change listener catches both.
      document.addEventListener('change', function (e) {
        var rootEl = document.getElementById('variant-update-' + sectionId);
        if (rootEl && e.target && rootEl.contains(e.target)) {
          setTimeout(function () { sync(wrap); }, 0);
          setTimeout(function () { sync(wrap); }, 120);
        }
      });
      sync(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSections);
  } else {
    watchSections();
  }
})();
